import { render, staticRenderFns } from "./PerfectInfo.vue?vue&type=template&id=5462b023&scoped=true&"
import script from "./PerfectInfo.vue?vue&type=script&lang=js&"
export * from "./PerfectInfo.vue?vue&type=script&lang=js&"
import style0 from "./PerfectInfo.vue?vue&type=style&index=0&id=5462b023&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462b023",
  null
  
)

export default component.exports